var exports = {
  "kL": "xcc377c0b--2e9e0a--container",
  "Sl": "xcc377c0b--2e9e0a--image",
  "Qq": "xcc377c0b--2e9e0a--text",
};

module.exports = exports;
